import React from "react";
import Color from 'color';

export function getOwnerIcon(_ref) {
    var _ref$fill = _ref.fill,
        fill = _ref$fill === undefined ? "#000" : _ref$fill,
        _ref$text = _ref.text,
        text = _ref$text === undefined ? "N/A" : _ref$text;


    var contrast = void 0;

    fill = Color(fill);

    if (fill.isDark()) {
        contrast = 'white';
    } else {
        contrast = 'black';
    }

    return React.createElement(
        "svg",
        { xmlns: "http://www.w3.org/2000/svg", width: "64", height: "64", viewBox: "0 0 64 64" },
        React.createElement("circle", { cx: "32", cy: "32", r: "27", fill: fill }),
        React.createElement(
            "text",
            { x: "32", y: "34", fill: contrast, fontFamily: "Akkurat, sans-serif", fontSize: "18", fontWeight: "normal", dominantBaseline: "middle", textAnchor: "middle" },
            text
        )
    );
}

export default getOwnerIcon;